import { User } from 'commonQuery/commonQueryDto';
import { createContext } from 'react';

type MyContextType = {
  userInfo: User;
};
export const MyContext = createContext<MyContextType | undefined>(undefined);
